RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsEngagementSummaryView = widgets.PostDetailsColumnView.extend({
        columnWidth: 6
    });


    const FbPostDetailsEngagementSummaryWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_engagement_summary_title,
        description: RivalIQ.strings.facebook_insights_post_detail_engagement_summary_description,
        view: FbPostDetailsEngagementSummaryView,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;
            const engagementRate = metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_RATE');

            return [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PERCENTAGE,
                    barTitle: RivalIQ.strings.facebook_insights_post_detail_engagement_summary_total_bar_title,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGED_USERS', {
                        name: engagementRate.get('name'),
                        description: engagementRate.get('description')
                    }),
                    divisor: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACH')
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_BREAKOUT,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGED_USERS'),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_ENGAGED_FANS',
                            'FACEBOOK_INSIGHTS_POST_ENGAGED_USERS_OTHER'
                        ]
                    })
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_ENGAGEMENT_SUMMARY, FbPostDetailsEngagementSummaryWidget);

});
